export function setString(key, string) {
    return {type: ACTION_SET_STRING, key, string};
}
export const ACTION_SET_STRING = 'QRY_ACTION_SET_STRING';
